// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"bca7f545","453":"154dfb50","890":"7c1ee17e"}[chunkId] + ".chunk.js";
};